import { FocusTrap } from 'focus-trap-react';
import * as React from 'react';
import { useClickOutsideRefObserver } from '~/Utils/Hooks/useClickOutsideObserver';

export interface FloatingWrapperProps {
    onClose: () => void;
    setFloatingElement: (element: HTMLDivElement) => void;
    floatingStyles: React.CSSProperties;
    ariaLabelledby: string;
    rootRef: React.RefObject<HTMLElement>;
    className?: string;
    open?: boolean;
}

export const FloatingWrapper: React.FC<React.PropsWithChildren<FloatingWrapperProps>> = props => {
    const { open, onClose, setFloatingElement, floatingStyles, ariaLabelledby, className, rootRef, children } = props;

    useClickOutsideRefObserver<HTMLElement>(rootRef, onClose);

    return (
        <FocusTrap
            active={open}
            focusTrapOptions={{
                allowOutsideClick: true,
                onDeactivate: onClose,
            }}
        >
            <div
                role="dialog"
                className={className}
                style={floatingStyles}
                aria-labelledby={ariaLabelledby}
                ref={setFloatingElement}
            >
                {children}
            </div>
        </FocusTrap>
    );
};
